module.exports = __webpack_public_path__ + "img/aprove.3c013199.svg";